import type { ReactNode } from 'react'
import React from 'react'

import { ConfigurationListItem } from '../ConfigurationListItem/ConfigurationListItem'
import * as S from './ConfigurationList.styled'

export type ConfigurationListProps = {
  children: ReactNode
}

export const ConfigurationList = ({ children }: ConfigurationListProps) => {
  return <S.Container>{children}</S.Container>
}

ConfigurationList.Item = ConfigurationListItem
